import Form from "../components/form/Form"
import Icon from "../components/icon/Icon"
import switchPng from "./assets/images/switch-horizontal-01.svg"
import { useFormInstance } from "../components/form/FormContext"
import { useEffect, useState } from "react"
import upload_fileApi from "../api/upload_file.api"
import Env from "../../Env"
import documentApi, { DocumentDetailDTO } from "../api/document.api"

import "./TranslationPreview.scss"
import { useMask } from "../components/mask/Mask"
import { ConfirmModal } from "../components/modal/Modal"
import Button from "../components/Button"
import { Flex } from "antd"
import { useTranslate } from "../components/language"

const SelectOptionsFrom = [
    {label: "Auto-detect", value: "Auto-detect"},
]


export default (props: {docId: string}) => {

  const {
    docId
  } = props

  const formInstance = useFormInstance({autoValidate: false})
  const [support_languages, setSupportLanguages] = useState<{label: string, value: string}[]>([])
  const {render: maskRender, show, close} = useMask()
  const [doc, setDoc] = useState<DocumentDetailDTO>()
  const { t } = useTranslate();
  const get_support_languages = () => {
        if (support_languages.length > 0){
            return support_languages
        }
        return SelectOptionsFrom.map((item) => ({...item, label: t(item.label), value: t(item.value)}))
    }

    const upgradeContentRender = () => {
        return (
            <div className="upgrade-content">
                <div className="title">{t("Get professional translation services with guaranteed quality and fast delivery")}</div>
                <ol>
                  <li><b>{t("Professional Team")}: </b>{t("Certified translators with years of experience")}</li>
                  <li><b>{t("Fast Delivery")}: </b>{t("24-hour turnaround time guaranteed")}</li>
                  <li><b>{t("Format Retention")}: </b>{t("24-hour turnaround time guaranteed")}</li>
                </ol>
            </div>
        )
    }

    const showUpgradeModal = () => {
        show(
          <ConfirmModal
              title={t("Upgrade to Translation Pro")} 
              content={upgradeContentRender()}
              onCancel={close} 
              onConfirm={() => {
                  close();
                  // doSubmit(form);
              }}
              confirmLabel={`Upgrade in ${proPriceRender()}`}
              width={"577px"}
          />
        )
      }

    const onPayHandle = () =>{
      documentApi.checkout({id: docId}).then((checkout_url) => {
        Env.DEBUG && console.log("checkout:", checkout_url)
        location.href = checkout_url
      })
    }

    const priceRender = () => {

      if(doc && doc.pricing_info && doc.pricing_info.price){
        const price = doc.pricing_info.price * 0.01
        return `$${price.toFixed(2)}`
      }

    }

    const proPriceRender = () => {

      if(doc && doc.pricing_info && doc.pricing_info.pro_price){
        const price = doc.pricing_info.pro_price * 0.01
        return `$${price.toFixed(2)}`
      }

    }

    const btnRender = () => {
      if(doc && doc.status === "WAITING_PAYMENT"){

        return (
          <div className="payment-btns">
            <Button.WhiteBg style={{minWidth: "274px"}} onClick={showUpgradeModal}>{t("Upgrade to Translation Pro")}</Button.WhiteBg>
            <Button.Primary style={{minWidth: "216px"}} onClick={onPayHandle}>{t("Full Translation for prefix") + priceRender() + t("Full Translation for suffix")}</Button.Primary>
          </div>
        )
      }else{
        return <></>
      }
      
    }

    const pageRender = () => {

      const info = doc?.preview_info
      if(!info){
        return <></>
      }
      const pageCount = info.image_count
      return (
        <div className="pages" >
          <Flex vertical gap={16}>
            {Array.from({length: pageCount}).map((_, index) => (
              <Flex justify="between" gap={32}>
                <div style={{flex: 1}}>
                  <img style={{width: "100%", height: "auto"}} src={info.original_preview_images[index]}></img>                
                </div>
                <div style={{flex: 1}}>
                  <img style={{width: "100%", height: "auto"}} src={info.translated_preview_images[index]}></img>
                </div>
              </Flex>
            ))}
          </Flex>
        </div>
      )
    }
    
    useEffect(() => {
        upload_fileApi.get_target_languages().then(data => {
            setSupportLanguages(data)
            Env.DEBUG && console.log("support languages:", data)
          })
          // documentApi.detail({id: "6871d8ebb3b2aff598da3216"})
    }, [])


    useEffect(() => {
      if(docId){
        documentApi.detail({id: docId, include_previews: 1}).then((docData) => {
          setDoc(docData)
          // Set form values using the document's actual target language
          formInstance.setInitial({
            source_language: t("Auto-detect"),
            target_language: docData.target_language || "",
          })
        })
      }
    }, [docId])


  return (
    <div className="translation-preview">
            <div className="header">
                <div className="title">{t("Preview translation file")}</div>
                <div className="description">{t("We have translate the first 3 pages as a preview. To access full translated file, please proceed to full translation.")}</div>
            </div>
            <div className="form-container">
              <Form.Form instance={formInstance} showError={false}>
                <div className="form">
                    <div className="languages">
                          <div className="language">
                              <Form.Item name="source_language" label="" nowrap>
                                  <Form.Select
                                      placeholder={t("Source language: Auto-detect")}
                                      options={SelectOptionsFrom}
                                      disabled={true}
                                      ></Form.Select>
                              </Form.Item>
                          </div>
                          <Icon src={switchPng} size={20} padding={12}/>
                          <div className="language">
                              <Form.Item name="target_language" label="" nowrap>
                                  <Form.Select
                                      placeholder="Target language: Select the target language"
                                      options={get_support_languages()}
                                      disabled={true}
                                      ></Form.Select>
                              </Form.Item>
                          </div>
                      </div>            
                </div>
              </Form.Form>
            </div>
            {maskRender}
            {btnRender()}
            {pageRender()}
        </div>
  )
}